<template>
  <div class="container" style="background-color: #fdfdfe">
    <div class="top_title">
      <!-- 返回按钮 -->
      <router-link class="icon_back" :to="{ path: 'H800020' }" tag="span" replace></router-link>
      <span style="padding-right: 2.4rem">电子合同查看</span>
    </div>
    <div class="scroll_area" :style="'overflow-y: auto;height: '+height+'px;'">
      <div style="margin-top: 2.4rem;margin-left: .5rem;margin-right: .5rem;">

        <pdf ref="myPdfComponent" :src="PDAPath"></pdf>
        <pdf :src="PDAPath" :page="2"></pdf>
        <div style="display: flex;justify-content: center;align-items: center;">
          <a class="btn" download :href="PDAPath">下载</a>
        </div>
        <div style="height: 3rem;"></div>
      </div>

    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import weui from "weui.js";
import dataRequestFactory from "../factories/dataRequestFactory";

export default {
  data() {
    return {
      width: '',
      height: '',
      PDAPath: '',
      I_SCHOOL_VALUE: '',
      I_TEL: '',
      I_STUDENT_NAME: '',
    }
  },
  components: {
    pdf
  },
  created() {
    this.width = $(window).width();
    this.height = $(window).height();

    window.document.title = '易文乐未消耗课时退费'

  },
  mounted() {
    var win_h = $(window).height();  //关键代码
    $("body").height(win_h);  //关键代码

    let params = this.$route.params

    if (params.I_SCHOOL_NO) {
      this.I_SCHOOL_VALUE = params.I_SCHOOL_NO
    } else {
      this.I_SCHOOL_VALUE = window.localStorage.getItem("I_SCHOOL_NO") || ''
    }

    if (params.I_PHONE) {
      this.I_TEL = params.I_PHONE
    } else {
      this.I_TEL = window.localStorage.getItem("I_PHONE") || ''
    }

    if (params.I_STUDENT_NAME) {
      this.I_STUDENT_NAME = params.I_STUDENT_NAME
    } else {
      this.I_STUDENT_NAME = window.localStorage.getItem("I_STUDENT_NAME") || ''
    }

    if (params.PDAPath) {
      this.PDAPath = params.PDAPath
      weui.toast('电子合同生成成功')
    }

    let requestParams = {
      "I_SCHOOL_NO": this.I_SCHOOL_VALUE,
      "I_PHONE": this.I_TEL,
      "I_STUDENT_NAME": this.I_STUDENT_NAME,
    }
    dataRequestFactory.I800040(requestParams).then(res => {
      if (res.resultCode === '0') {
        this.PDAPath = 'http://' + res.I_SIGN_FILE
      }
    }).catch(err => {
      if (err.errorDesc === '请选择校区') {
        this.$router.replace({name: 'H800010'})
      }
    })
  }
}
</script>

<style scoped>
.btn {
  height: 2.38rem;
  line-height: 2.28rem;
  color: #1277f8;
  text-align: center;
  font-size: 0.8rem;
  display: block;
  width: 6rem;
  background-color: #FFF;
  border-radius: 6px;
  border: 0.1rem solid #1277f8;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/H800040.vue